export default __webpack_public_path__ + "static/media/bg2.7b9efff3.png";